import { render } from "./GameFooter.vue?vue&type=template&id=4a21b7fa&scoped=true"
import script from "./GameFooter.vue?vue&type=script&lang=js"
export * from "./GameFooter.vue?vue&type=script&lang=js"

import "./GameFooter.vue?vue&type=style&index=0&id=4a21b7fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a21b7fa"]])

export default __exports__